import React from 'react';
import loadable from '@loadable/component';

const Chart = (props) => {
  const Component = loadable(() => import('./Chart.js'), { ssr: false });
  return <Component {...props} />;
};

export default Chart;
